// noinspection SpellCheckingInspection

/** @category Enums */
// Values should correlate with 'SemanticUrlPath' a.k.a what is in the URL.
export enum BankEnum {
  OstfoldAkershus = 'ostfold-akershus',
  Ostlandet = 'ostlandet',
  LomSkjaak = 'lom-skjaak',
  Gudbrandsdal = 'gudbrandsdal',
  RingerikeHadeland = 'ringerike-hadeland',
  HallingdalValdres = 'hallingdal',
  SrBank = 'sr-bank',
  Nordmore = 'nordmore',
  Smn = 'smn',
  NordNorge = 'nord-norge',
  Helgeland = 'helgeland',
  Sorost = 'sorost',
  SognOgFjordane = 'sognogfjordane',
  /** Not specific to a single bank, i.e. open pages */
  All = 'all',
  /** 'none' is set when the current bank is unknown, or not applicable in the current context */
  None = 'none',
}

/** @category Enums */
export enum OptInEnum {
  Functional = 'FUNCTIONAL',
  Marketing = 'MARKETING',
  Statistics = 'STATISTICS',
}

/** @category Enums */
export enum LanguageEnum {
  nn = 'nn',
  nb = 'nb',
  en = 'en',
}

/** @category Enums */
export enum AppContextEnum {
  aapneSider = 'aapne-sider',
  digitalbank = 'digitalbank',
  kreditt = 'kreditt',
  fremtind = 'fremtind',
  eiendomsmegler1 = 'eiendomsmegler1',
  mobilbankIos = 'mobilbank-ios',
  mobilbankAndroid = 'mobilbank-android',
  /** 'intern' is used for applications that are outside the typical contexts and will only go to Humio for simple usage data. */
  intern = 'intern',
}

/** @category Enums */
export enum BusinessUnitEnum {
  SpareBank1 = 'SpareBank 1',
  Kreditt = 'SpareBank 1 Kreditt',
  Fremtind = 'Fremtind',
  EiendomsMegler1 = 'EiendomsMegler 1',
}

/** @category Enums */
// Bank values should correlate with 'SemanticUrlPath' a.k.a what is in the URL.
export enum SubBrandEnum {
  /** Not specific to a single bank, i.e. open pages */
  Bank = 'bank',
  Ostfold = 'ostfold-akershus',
  Ostlandet = 'ostlandet',
  LomSkjaak = 'lom-skjaak',
  Gudbrandsdal = 'gudbrandsdal',
  RingerikeHadeland = 'ringerike-hadeland',
  HallingdalValdres = 'hallingdal',
  SrBank = 'sr-bank',
  Nordmore = 'nordmore',
  Smn = 'smn',
  NordNorge = 'nord-norge',
  Helgeland = 'helgeland',
  Sorost = 'sorost',
  SognOgFjordane = 'sognogfjordane',
  Kreditt = 'kreditt',
  Fremtind = 'fremtind',
  /** 'none' is set when the current bank is unknown, and should only happen if there is a mapping error */
  None = 'none',
  // EM1
  /** EM1 Felles. Shared pages in EM1. Similar to 'bank' SubBrand, but for EM1. */
  Em1Felles = 'em1felles',
  /** EM1 SR-Eiendom */
  Em1Sr = 'em1sr',
  /** EM1 Nord-Norge */
  Em1Nn = 'em1nn',
  /** EM1 Innlandet */
  Em1Inn = 'em1inn',
  /** EM1 Midt-Norge */
  Em1Mn = 'em1mn',
  /** EM1 Oslo og Akershus */
  Em1Oah = 'em1oah',
  /** EM1 Østfold Akershus */
  Em1Oea = 'em1oea',
  /** EM1 Telemark */
  Em1Tel = 'em1tel',
  /** EM1 Sørøst-Norge */
  Em1Bv = 'em1bv',
  /** EM1 Fjellmegleren */
  Em1Fjell = 'em1fjell',
  /** EM1 Ringerike Hadeland */
  Em1Rh = 'em1rh',
  /** EM1 Lillehammer Gudbrandsdal */
  Em1Lg = 'em1lg',
  KredittBnbank = 'bnbank',
  KredittCoop = "coop",
  KredittSbm = "sbm",
  KredittLofavor = "lofavor",
  KredittInnskudd = "innskudd",
  Sparebank1Kreditt = "sparebank1-kreditt",
}

/** @category Enums */
export enum DestinationEnum {
  Adobe = 'ADOBE',
  Humio = 'HUMIO',
  Datavarehus = 'DATAVAREHUS',
}

/** @category Enums */
export enum LinkTypeEnum {
  /** A "default" button, if none of the other link types fit. */
  Button = 'button',
  /** Link that opens a menu. A hamburger menu for instance. */
  Menu = 'menu',
  /** A link that is used to navigate "something". A typical example are links like "next" or "previous" to navigate between the different parts of a form. */
  Navigation = 'navigation',
  /** Link to an external resource. */
  External = 'external',
  /** Login link. */
  Login = 'login',
  /** A promotional link. The user clicks a promotional banner for instance. */
  Promotion = 'promotion',
  /** A link in which the purpose is to offer the user a shortcut to another part of the webpage. */
  Shortcut = 'shortcut',
  /** Downloads an item. */
  Download = 'download',
  /** Expands or closes a section in an accordion. */
  Accordion = 'accordion',
  /** Expands a dropdown menu. */
  Dropdown = 'dropdown',
  /** Link that switches between tabs  */
  Tab = 'tab',
}

/** @category Enums */
export enum CookieEnum {
  DeclaredId = 'DECLAREDID',
  SessionId = 'DSESSIONID',
  Sb1OptinAuthenticated = 'sb1-optin-authenticated',
  Sb1OptinAuthenticatedV2 = 'sb1-optin-authenticated-v2',
  AdobeIdentity = 'kndctr_34D5E37A5447B2650A4C98C6_AdobeOrg_identity',
  AdobeAmcv = 'AMCV_34D5E37A5447B2650A4C98C6%40AdobeOrg',
  PrintSignal = 'print_signal',
}

/** @category Enums */
export enum EventNameEnum {
  PageLoaded = 'PageLoaded',
  FormInitiated = 'FormInitiated',
  FormStepStarted = 'FormStepStarted',
  FormStepCompleted = 'FormStepCompleted',
  FormCanceled = 'FormCanceled',
  FormErred = 'FormErred',
  FormCompleted = 'FormCompleted',
  ConsentChanged = 'ConsentChanged',
  ButtonClicked = 'ButtonClicked',
  Login = 'Login',
  Search = 'Search',
  InternalPromotionClicked = 'InternalPromotionClicked',
  ZipSearch = 'ZipSearch',
  ZipSearchClick = 'ZipSearchClick',
  ZipSearchClickPrefilled = 'ZipSearchClickPrefilled',
  FindYourBankClick = 'FindYourBankClick',
  FindYourBankClickPrefilled = 'FindYourBankClickPrefilled',
  CalculatorInteraction = 'CalculatorInteraction',
  CalculatorApplyForLoan = 'CalculatorApplyForLoan',
  CalculatorContactUs = 'CalculatorContactUs',
  ComponentViewed = 'ComponentViewed',
  VideoStart = 'VideoStart',
  VideoEnd = 'VideoEnd',
  VideoUpdate = 'VideoUpdate',
  AutoBankRedirect = 'AutoBankRedirect',
  GoogleBankRedirect = 'GoogleBankRedirect',
  DiscountPromoClicked = 'DiscountPromoClicked',
  DiscountOpenBox = 'DiscountOpenBox',
  DiscountExposed = 'DiscountExposed',
  FaqRead = 'FaqRead',
  FeedbackGiven = 'FeedbackGiven',
}

/**
 * Predefined values for what rating the different emojis are, so that we ensure that there is no room for interpretation.
 *
 * @category Enums
 */
export enum FeedbackEmojiEnum {
  ThumbsDown = '1',
  ThumbsUp = '10',
  Frowning = '1',
  SlightlyFrowning = '3',
  Neutral = '5',
  SlightlySmiling = '7',
  Smiling = '10',
}

/**
 * Predefined values for which Adobe environment the data should go to. See: {@link Adobe | Adobe.adobeEnv} for details.
 *
 * @category Enums
 */
export enum AdobeEnvEnum {
  Dev = 'dev',
  Prod = 'prod',
}

/**
 * Predefined values for the current environment. Used for {@link InitParams | InitParams.backendEnvironment}
 *
 * @category Enums
 */
export enum BackendEnvironmentEnum {
  Test = 'test',
  Prod = 'prod',
}

// TypeDoc
/**
 * These are the regexes used in the backend to validate the values that are sent.
 * If there is a constraint violation, the tracking event will be discarded.
 * @category Enums
 */
export enum Validators {
  genericProperty = '^[0-9a-zA-ZÆØÅæøå\\s:;/|_\\-]{0,100}+$',
  internalPromotionName = '[a-zA-ZæøåÆØÅ\\d;\\-,_]+$',
  buttonText = '^.{0,100}+$',
  productName = '^[a-z_-]{0,100}+$',
  productCategory = '^[a-z0-9\\-_]{0,100}+$',
  productEntry = '^[a-z_-]{0,100}+$',
  customData = '^[0-9a-zA-ZÆØÅæøå\\s\\-]{0,100}+$',
  customDataKey = '^[a-zA-Z]{0,50}+$',
  userInput = '[a-zA-ZæøåÆØÅ0-9\\s,+_–"/|().?*\\-\\\\]{0,120}',
}
